/**
 * Project : workspace
 * File    : CustomerDetailScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.customer.detail

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.commerce.feature.customer.viewModel.CustomerViewModel
import com.parmartechnologies.commerce.feature.invoice.viewModel.InvoiceViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.ui.component.image.ImageView
import component.button.DefaultButton
import component.loader.AppLoader
import component.navigation.TopNavBar
import component.text.TextRow
import navigation.AppNavigator
import navigation.route.customer.CustomerNavRoute
import navigation.route.invoice.InvoiceNavRoute
import presentation.screens.business.invoice.component.InvoiceCard
import theme.ThemeColor

/**
 * Represents the customer detail screen class.
 */

class CustomerDetailScreen{
    @Composable
    fun Content() {
        val viewModel = CustomerViewModel(BusinessHandler.shared().repository.myBusiness.value)
        val customer = AppNavigator.shared().getNavigationParam().customer
        
        val selectedIndex = remember { mutableStateOf(0) }
        val invoiceViewModel = InvoiceViewModel(viewModel.business)
        val invoices = invoiceViewModel.allCustomerInvoice.collectAsState()
        LaunchedEffect(key1 = Unit) {
            customer._id.let { invoiceViewModel.loadForUserCustomer(it) }
        }
        /**
 * Executes the get selected color operation.
 *
 * @receiver TODO
 * @param index The index.
 * @return The resulting color.
 */
        fun getSelectedColor(index: Int = 0): Color {
            if (index == selectedIndex.value) {
                return ThemeColor.shared().PrimaryColor
            } else {
                return ThemeColor.shared().lightGray
            }
        }

        /**
 * Executes the get selected text color operation.
 *
 * @receiver TODO
 * @param index The index.
 * @return The resulting color.
 */

        fun getSelectedTextColor(index: Int = 0): Color {
            if (index == selectedIndex.value) {
                return ThemeColor.shared().White
            } else {
                return ThemeColor.shared().White
            }
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Customer", NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            })
            AppLoader(viewModel)

            LazyColumn(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
                item {
                    Row(modifier = Modifier.fillMaxWidth().height(200.dp)) {
                        ImageView(customer?._id,customer.BusinessID)
                    }
                }
                item {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(8.dp).height(50.dp).background(
                            color = ThemeColor.shared().cardBackground,
                            shape = RoundedCornerShape(250.dp)
                        ).padding(start = 0.dp, end = 9.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.3f)
                                .padding(start = 8.dp, end = 8.dp, top = 8.dp, bottom = 8.dp)
                                .background(getSelectedColor(0), shape = RoundedCornerShape(20.dp))
                                .clickable {
                                    selectedIndex.value = 0
                                },
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            Text(
                                "Info",
                                color = getSelectedTextColor(0),
                                fontSize = 15.sp,
                                fontStyle = FontStyle.Normal,
                                fontWeight = FontWeight(700)
                            )
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.3f)
                                .padding(start = 8.dp, end = 8.dp, top = 8.dp, bottom = 8.dp)
                                .background(getSelectedColor(1), shape = RoundedCornerShape(20.dp))
                                .clickable {
                                    selectedIndex.value = 1
                                },
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            Text(
                                "Invoices", color = getSelectedTextColor(1),
                                fontSize = 15.sp,
                                fontStyle = FontStyle.Normal,
                                fontWeight = FontWeight(700)
                            )
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.3f)
                                .padding(start = 8.dp, end = 8.dp, top = 8.dp, bottom = 8.dp)
                                .background(getSelectedColor(2), shape = RoundedCornerShape(20.dp))
                                .clickable {
                                    selectedIndex.value = 2
                                },
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            Text(
                                "Visits", color = getSelectedTextColor(2),
                                fontSize = 15.sp,
                                fontStyle = FontStyle.Normal,
                                fontWeight = FontWeight(700)
                            )
                        }
                    }
                }
                if (selectedIndex.value == 0) {
                    item {
                        Column(
                            modifier = Modifier.fillMaxWidth().fillMaxHeight().background(
                                color = ThemeColor.shared().cardBackground,
                                shape = RoundedCornerShape(8.dp)
                            ).padding(8.dp)
                        ) {
                            TextRow("name", customer?.Name ?: "")
                            TextRow("Email", customer?.EmailID ?: "")
                            TextRow(
                                "Mobile Number",
                                customer?.DialCode + customer?.MobileNumber
                            )
                            Row(
                                modifier = Modifier.fillMaxWidth().height(50.dp)
                                    .padding(start = 24.dp, end = 24.dp)
                            ) {
//                                SecondaryButton("Delete", {})
                                DefaultButton("Edit", {
                                    viewModel.editCustomer(customer)
                                    AppNavigator.shared().navigate(CustomerNavRoute.UPDATE)
                                })
                            }
                        }
                    }
                } else if (selectedIndex.value == 1) {
                    items(invoices.value.size) {
                        InvoiceCard(invoices.value[it]) {
                            invoiceViewModel.setSelectedInvoice(it)
                            AppNavigator.shared().navigate(InvoiceNavRoute.DETAILS)
                        }
                    }
                } else if (selectedIndex.value == 2) {
                    item {
                        Row(
                            modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.3f)
                                .padding(start = 8.dp, end = 8.dp, top = 8.dp, bottom = 8.dp)
                                .background(getSelectedColor(2), shape = RoundedCornerShape(20.dp))
                                .clickable {
                                    selectedIndex.value = 2
                                },
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            TextRow(
                                "",
                                "Feature coming soon"
                            )
                        }
                    }
                }
            }
        }
    }
}